define('app/models/MonitorData',['require','glu/util','app/visualizations/FormatFactory'],function(require) {
	'use strict';

	var _ = require('glu/util'),
		FormatFactory = require('app/visualizations/FormatFactory');

	return function(data, monitor) {
		var formatOptions = function(header) {
			if (header) {
				var result = {};
				if (header.isPercentage) {
					result.displayFormat = 'percentage01';
				}
				return result;
			}
		};

		this.translateHeader = function(header) {
			if (header) {
				var result = {
					label: header.name,
					title: header.name,
					id: header.id,
					field: 'f' + header.index,
					metadata: header
				};

				if (header.id === 'SEGMENTS') {
					result.draggable = false;
				}

				var options = monitor.getOptions();
				if (options['columnWidth:' + header.index]) {
					result.width = options['columnWidth:' + header.index];
				}

				header.type = header.type || 'STR';
				result.format = FormatFactory.formatterForType(header.type, formatOptions(header));

				result.className = 'dt-' + header.type.toLowerCase();

				return result;
			}
		};

		this.translateRow = function(row) {
			if (data) {
				var output = {};
				_.each(data.header, function(header, i) {
					output['f' + header.index] = row[i];
				});
				return output;
			}
		};

		this.columns = function() {
			return _.map(data.header, this.translateHeader);
		};

		this.rows = function() {
			return _.map(data.rows, this.translateRow);
		};

		this.sort = function(index, direction) {
			if (!data || !data.header || !data.header[index]) {
				return;
			}

			var sorting = {};
			sorting[data.header[index].id] = sorting[data.header[index].id] || {};
			sorting[data.header[index].id].sort = sorting[data.header[index].id].sort || {};
			sorting[data.header[index].id].sort = (direction || 'asc');

			monitor.setOption('sorting', sorting);
		};

		this.getSort = function() {
			var sorting = monitor.getOptions().sorting || {};
			var defaultSort = {};
			for (var i = 0; i < data.header.length; i++) {
				if (sorting[data.header[i].id] && sorting[data.header[i].id].sort) {
					defaultSort.field = 'f' + data.header[i].index;
					defaultSort.order = sorting[data.header[i].id].sort.toLowerCase();
				}
			}
			return defaultSort;
		};
	};

});

